
import React, { useState, useEffect, useCallback } from 'react';
import { Grid, Typography, TextField, Fab } from '@mui/material';
import { getCaptcha } from '../../services/user-services';
import CachedIcon from '@mui/icons-material/Cached';
import Notification from "../notification/notification"
import { convertToFaToEn } from '../../services/utils'

export default function CaptchaUser({ reqCaptch, onBack }) {
    const [imageCaptcha, setImageCaptcha] = useState('')
    const [captchaKey, setCaptchaKey] = useState(null)
    const [captchaText, setCaptchaText] = useState('')
    const [notiShow, setNotiShow] = useState(false)
    const [notiTitle, setNotiTitle] = useState('')
    const [notiType, setNotiType] = useState("success")

    const dataCheck = useCallback(async () => {
        await getCaptcha()
        .then((res) =>{
            if (res?.captcha_image) {
                setCaptchaKey(res.captcha_key)
                setImageCaptcha(`data:${res.image_type};${res.image_decode},${res?.captcha_image}`)
            }
        })
        .catch((err) =>{
            console.error("Captcha error:", err)
        })
    }, [])

    const handlerCaptcha = () => {
        dataCheck()
    }
    
    useEffect(() => {
        dataCheck()
        setCaptchaText('')
    }, [reqCaptch, dataCheck])

    const handleBack = (e, value) => {
        e.preventDefault();
        setCaptchaText(value)
        const regData = {
            captcha_val: value,
            captcha_key: captchaKey
        }
        onBack(regData)
    }

    const handlerBackNoti = () => {
        setNotiShow(false)
    }

    return (
        <div className="text-right">
            {imageCaptcha &&
                <div className="p-2">
                    <img
                        src={imageCaptcha}
                        alt="captcha"
                        width={170}
                        height={100}
                        style={{ margin: 1, width: "auto", height: "auto" }}
                    />
                    <Grid container spacing={2} alignItems='flex-end'>
                        <Grid item>
                            <Fab
                                variant="extended"
                                size="medium"
                                color="primary"
                                onClick={handlerCaptcha}
                            >
                                <CachedIcon sx={{ mr: 1 }} />
                            </Fab>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                label={
                                    <Typography
                                        fontFamily='vaziri_light'
                                        component="span"
                                        variant="h6"
                                    >
                                        عبارت را وارد کنید
                                    </Typography>
                                }
                                value={captchaText}
                                sx={{ minWidth: "150px" }}
                                autoComplete="off"
                                inputProps={{
                                    style: { fontFamily: "Segoe UI", fontSize: 24 }
                                }}
                                variant="standard"
                                type='text'
                                onChange={(e) => {
                                    const val = e.target.value
                                    // setCaptchaText(val) // همیشه مقدار input رو نشون بده
                                    const re = /^[a-zA-Z0-9]+$/
                                    if (val === "" || (re.test(val) && val.length <= 6)) {
                                        handleBack(e, convertToFaToEn(val))
                                    } else {
                                        setNotiShow(true)
                                        setNotiTitle('لطفا عبارت را با دقت بنویسید !!!')
                                        setNotiType("error")
                                    }
                                }}
                                
                            />
                        </Grid>
                    </Grid>
                </div>
            }
            <div>
                <Notification
                    viewNoti={notiShow}
                    title={notiTitle}
                    severity={notiType}
                    onBack={handlerBackNoti}
                />
            </div>
        </div>
    )
}
